// extracted by css-extract-rspack-plugin
export default {"ProductAnnouncementBannerAnimation":"ProductAnnouncementBannerAnimation-module__ProductAnnouncementBannerAnimation__nHT5e"};